// ثيم MUI موحّد مع اتجاه RTL وألوان وهوية المشروع
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  direction: "rtl",
  palette: {
    mode: "light",
    primary: { main: "#543198", contrastText: "#fff" },
    secondary: { main: "#6b54d6" },
    background: { default: "#f4f7fb", paper: "#ffffff" },
    text: { primary: "#111827", secondary: "#637285" },
    error: { main: "#e53935" },
    warning: { main: "#F0B13B" },
    info: { main: "#0288d1" },
    success: { main: "#2e7d32" },
  },
  shape: { borderRadius: 4 },
  typography: {
    fontFamily: '"Cairo", system-ui, -apple-system, "Segoe UI", Roboto, Arial',
    h1: { fontWeight: 800, fontSize: "2.25rem" },
    h2: { fontWeight: 800, fontSize: "1.875rem" },
    h3: { fontWeight: 800, fontSize: "1.5rem" },
    body1: { lineHeight: 1.9 },
    button: { textTransform: "none", fontWeight: 700 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 4, paddingInline: 18, paddingBlock: 10 },
      },
    },
    MuiContainer: { defaultProps: { maxWidth: "lg" } },
    MuiCssBaseline: {
      styleOverrides: {
        ":root": {
          "--brand": "#543198",
          "--brand-2": "#6b54d6",
          "--cta": "#ff5733",
          "--bg": "#f4f7fb",
          "--border": "#e6eaf0",
        },
        html: { scrollBehavior: "smooth" },
        body: { backgroundColor: "#f4f7fb" },
      },
    },
  },
});

export default theme;
